import {Button} from '@chekinapp/ui';

import {hasSession} from 'components/sessions/utils';
import {useSessionExpiryPolicy} from 'components/sessions/useSessionExpiryPolicy';
import {useTranslation} from 'react-i18next';
import {LogOut} from 'lucide-react';
import {useReservation} from 'context/reservation';

function EndSessionButton() {
  const {t} = useTranslation();
  const {reservationId} = useReservation();
  // Same policy the idle countdown and SessionCloseModal use, so all three
  // exits leave the terminal in the same state.
  const {onExpire: endSession} = useSessionExpiryPolicy();

  if (!hasSession(reservationId)) {
    return null;
  }
  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={endSession}
      className="end-session-button fixed bottom-[8%] right-4 z-10 h-10 min-w-[auto] gap-1.5 rounded-full px-4 text-[13px] [--button-icon-size:16px] [--button-secondary-bg:var(--chekin-color-white)] [--button-secondary-border:transparent] [--button-secondary-text:var(--chekin-color-brand-navy)] [box-shadow:var(--chekin-shadow-elev)] kiosko:hidden"
    >
      <LogOut />
      {t('exit')}
    </Button>
  );
}

export {EndSessionButton};
